/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React, {Ref} from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

interface BotIconProps extends IconProps {
  eyesRef?: Ref<SVGGElement>;
  blinkRef?: Ref<SVGGElement>;
  svgRef?: Ref<SVGSVGElement>;
}

/*
 * Defines the Design Language System (DLS) Bot Icon component.
 */
export const BotIcon = ({
  size = IconSize.small, color = dlsColor('grey3'), eyesRef, blinkRef, svgRef
}: BotIconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, color});
  return (
    <svg ref={svgRef} width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M12 7V3.5C12 3.22386 11.7761 3 11.5 3H8'
        stroke={iconColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M18 7H6C4.89543 7 4 7.89543 4 9V17C4 18.1046 4.89543 19 6 19H18C19.1046 19 20 18.1046 20 17V9C20 7.89543 19.1046 7 18 7Z'
        stroke={iconColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M2 13H4' stroke={iconColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M20 13H22' stroke={iconColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <g ref={eyesRef} style={{transition: 'transform 500ms cubic-bezier(0.0, 0.0, 0.2, 1)'}}>
        <g ref={blinkRef} style={{transformOrigin: '12px 13px', transition: 'transform 120ms ease-in-out'}}>
          <path d='M15 12V14' stroke={iconColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          <path d='M9 12V14' stroke={iconColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        </g>
      </g>
    </svg>
  );
};
